import { fetcher } from "helpers/fetcher";

import { TGetSchoolTypeReq, TGetSchoolTypeRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getSchoolType = async () => {
  return await fetcher<TGetSchoolTypeRes, TGetSchoolTypeReq>(
    ENDPOINT.USER.GET_SCHOOOL_TYPE,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_SCHOOOL_TYPE.version,
      },
    }
  );
};

export const queryGetSchoolType = async () => {
  return (await getSchoolType()).data;
};

queryGetSchoolType._key = () => [ENDPOINT.USER.GET_SCHOOOL_TYPE.url];
